export default __webpack_public_path__ + "static/media/key.5c0814b1.png";